// extracted by css-extract-rspack-plugin
export default {"legacy":"legacy__legacy___s8YyA common__button___UCWIz common__bold___ve4Qa"};